import styled from 'styled-components';
import { color } from 'theme';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import {
    GREY_400, GREY_700, GREY_800,
} from '../../../constants';

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.25rem 0 0;
`;

export const InfoCard = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border-radius: 0.375rem;
    background: rgba(0, 0, 0, 0.04);
`;

export const InfoIcon = styled.span`
    display: flex;
    flex-shrink: 0;
    color: ${color('brand.main')};

    svg {
        width: 1.25rem;
        height: 1.25rem;
    }
`;

export const InfoTitle = styled.div`
    color: ${GREY_800};
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.375rem;
`;

export const InfoText = styled.div`
    color: ${GREY_400};
    font-size: 0.75rem;
    line-height: 1.25rem;
`;

export const FieldValueRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    padding: 0.625rem 0.75rem;
`;

export const FieldValue = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: ${GREY_700};
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledCopyToClipboardButton = styled(CopyToClipboardButton)`
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
`;

export const HelpText = styled.p`
    margin: 0;
    color: ${GREY_400};
    font-size: 0.75rem;
    line-height: 1.25rem;
    text-align: center;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 4px 0 0;
`;
